import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <RankingSection />
        <CardsSection />
        <AboutSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}